import { __rest } from 'tslib';
import { InjectorService } from '@tencent/ioc';

/**
 * Service 装饰器，用于声明一个新的 Service，注入到其它 Service 或 Feature 的 `constructor` 中。
 *
 * @param options - Service 选项
 * @public
 * @decorator
 */
function Service(options = {}) {
    return (target) => {
        const { provide, name } = options, rest = __rest(options, ["provide", "name"]);
        if (name) {
            target.displayName = name;
        }
        if (provide) {
            InjectorService.service(provide, target, Object.assign(Object.assign({}, rest), { type: 'service' }));
        }
        else {
            InjectorService.service(target, Object.assign(Object.assign({}, rest), { type: 'service' }));
        }
        InjectorService.invokable(target);
        return target;
    };
}

export { Service };
//# sourceMappingURL=service.js.map
